import { useEffect, useState } from 'react';
import axios from 'axios';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const FearGreedWidget = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchFearGreed = async () => {
      try {
        const response = await axios.get(`${API}/bitcoin/fear-greed`);
        setData(response.data.data[0]);
      } catch (error) {
        console.error('Error fetching fear & greed:', error);
      }
    };

    fetchFearGreed();
    const interval = setInterval(fetchFearGreed, 300000);
    return () => clearInterval(interval);
  }, []);

  if (!data) return null;

  const value = parseInt(data.value);
  const chartData = [
    { name: 'Value', value: value },
    { name: 'Remaining', value: 100 - value }
  ];

  const getColor = (val) => {
    if (val <= 25) return '#EF4444';
    if (val <= 45) return '#F59E0B';
    if (val <= 55) return '#6B7280';
    if (val <= 75) return '#84CC16';
    return '#10B981';
  };

  const getLabel = (val) => {
    if (val <= 25) return 'Medo Extremo';
    if (val <= 45) return 'Medo';
    if (val <= 55) return 'Neutro';
    if (val <= 75) return 'Ganância';
    return 'Ganância Extrema';
  };

  const statusSteps = [
    { label: 'Medo Extremo', color: '#EF4444', range: '0–25' },
    { label: 'Medo', color: '#F59E0B', range: '26–45' },
    { label: 'Neutro', color: '#6B7280', range: '46–55' },
    { label: 'Ganância', color: '#84CC16', range: '56–75' },
    { label: 'Ganância Extrema', color: '#10B981', range: '76–100' },
  ];

  const updateTime = data.timestamp ? new Date(Number(data.timestamp) * 1000) : null;

  return (
    <div className="bg-gradient-to-br from-slate-950 via-slate-900 to-slate-800 border border-slate-700 rounded-3xl p-6 shadow-xl" data-testid="fear-greed-widget">
      <div className="flex flex-col gap-4 md:flex-row md:items-start md:justify-between">
        <div>
          <p className="text-xs uppercase tracking-[0.32em] text-slate-500">Sentimento do mercado</p>
          <h3 className="text-2xl font-semibold text-white mt-2">Índice de Medo e Ganância</h3>
          <p className="mt-2 max-w-md text-sm text-slate-400">
            Um termômetro rápido do apetite do mercado por risco em criptomoedas. Use como referência, não como recomendação.
          </p>
        </div>
        {updateTime && (
          <div className="text-right text-sm text-slate-400">
            <p>Última atualização</p>
            <p className="mt-1 font-semibold text-white">{updateTime.toLocaleString('pt-BR')}</p>
          </div>
        )}
      </div>

      <div className="mt-6 flex flex-col items-center gap-6">
        <div className="relative w-[240px] h-[240px]">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={chartData}
                cx="50%"
                cy="50%"
                startAngle={180}
                endAngle={0}
                innerRadius={72}
                outerRadius={96}
                paddingAngle={1}
                dataKey="value"
              >
                <Cell fill={getColor(value)} />
                <Cell fill="#334155" />
              </Pie>
            </PieChart>
          </ResponsiveContainer>
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
            <span className="text-5xl font-semibold text-white">{value}</span>
            <span className="mt-2 text-sm uppercase tracking-[0.24em] text-slate-300">
              {getLabel(value)}
            </span>
          </div>
        </div>

        <div className="w-full space-y-3">
          <div className="h-3 rounded-full bg-slate-800 overflow-hidden shadow-inner ring-1 ring-slate-700">
            {statusSteps.map((step) => (
              <div
                key={step.label}
                className="h-full"
                style={{
                  width: `${100 / statusSteps.length}%`,
                  backgroundColor: step.color,
                }}
              />
            ))}
          </div>

          <div className="grid grid-cols-2 gap-2 text-xs text-slate-300 sm:grid-cols-3">
            {statusSteps.map((step) => (
              <div key={step.label} className="rounded-2xl border border-slate-700 bg-white/5 p-2">
                <div className="font-semibold text-white">{step.label}</div>
                <div className="text-slate-400">{step.range}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
